import IconFont from '@meitu/xdesign-icon-font';

const RotateAction: React.FC<{ isOperating: boolean }> = ({ isOperating }) => {
    return (
        <div
            className="l-cropStage-rotateAction operate-rotate operate-rotate-lt"
            data-type="rotate"
            style={{
                visibility: isOperating ? 'hidden' : 'visible',
            }}
        >
            <div className="l-operate__none-event rotate-icon">
                <IconFont name="RefreshBold" />
            </div>
        </div>
    );
};

export default RotateAction;
